import { render } from "./InformationSheetScreen.vue?vue&type=template&id=4000122f&scoped=true"
import script from "./InformationSheetScreen.vue?vue&type=script&lang=js"
export * from "./InformationSheetScreen.vue?vue&type=script&lang=js"

import "./InformationSheetScreen.vue?vue&type=style&index=0&id=4000122f&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4000122f"]])

export default __exports__